/**
 * 版號(側欄左下角顯示)。格式 `V[A].[B].[C]`:
 *
 *   A  產品發布版本(1 位):開發階段 0;整個專案完成開發後定義為 1。
 *   B  階段發布版本(2 位):四個交付階段 8/30、9/30、12/31、最後 → 01、02、03、04。
 *   C  開發版號(3 位):**issue 表有更新就 +1**,從 001 起算。
 *
 * 起始:V0.01.001(2026-09-07)。
 *
 * 只改這一個字串,不要碰 package.json 的 version(`0.01.001` 不是合法 semver)。
 * 每次改動要同時更新下方 VERSION_LOG,讓「這個號碼對到哪批 issue」查得到。
 */
export const APP_VERSION = "V0.01.003";

/** 版號 ↔ 對應的 issue 批次(新的放最上面) */
export const VERSION_LOG = [
  { version: "V0.01.003", date: "2026-09-10", note: "9/10 驗收回饋:看板 CVE/KEV 卡排版(台數與漏洞種數分行)、權限三態選中藍實底/未選淡灰、匯入結果明細可捲與徽章置中;機房與機櫃標準範本匯入" },
  { version: "V0.01.002", date: "2026-09-09", note: "八月唯讀驗收站(feat/uat-readonly-aug):驗收表 9/8-9/9(BUG-001~007、Rex 紅字);round 3 修復、看板 CVE 卡改綁受影響資產數、契約對齊、標準範本匯入、唯讀模式" },
  { version: "V0.01.001", date: "2026-09-07", note: "起始版號;UAT round 1 修復(.scratch/uat-round1)後的第一版" },
];

/** 版號格式(測試與 CI 守著,避免手滑打成 V0.1.1 之類) */
export const VERSION_PATTERN = /^V\d\.\d{2}\.\d{3}$/;
